var _class, _temp2;

var _templateObject = _taggedTemplateLiteralLoose(["padding-bottom: 0;"], ["padding-bottom: 0;"]);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import { media } from "../index";

var DELAY = 500;

var easeOutCubic = "cubic-bezier(0.215, 0.61, 0.355, 1)";

var ModalDimmer = styled.div.withConfig({
  displayName: "Modal__ModalDimmer",
  componentId: "cq621u-0"
})(["position:fixed;left:0;top:0;width:100%;height:100%;z-index:1000;background:rgba(0,0,0,0.35);overflow-x:hidden;overflow-y:auto;opacity:", ";transition:opacity 0.2s ", ";"], function (props) {
  return props.open ? "1" : "0";
}, easeOutCubic);

var ModalContent = styled.div.withConfig({
  displayName: "Modal__ModalContent",
  componentId: "cq621u-1"
})([""]);
var ModalContentWrapper = styled.div.withConfig({
  displayName: "Modal__ModalContentWrapper",
  componentId: "cq621u-2"
})(["font-family:", ";box-sizing:border-box;width:100%;height:100vh;transform:translateY(", ");will-change:transform;transition:transform ", "ms ", ";", " & > ", "{box-sizing:border-box;background:", ";height:", ";padding-bottom:100px;", ";overflow-y:auto;-webkit-overflow-scrolling:touch;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily;
}, function (props) {
  return props.open ? "0" : "-110%";
}, DELAY, easeOutCubic, function (props) {
  return !props.fullscreen && css(["display:flex;justify-content:center;align-items:flex-start;& > div{max-width:600px;max-height:100%;}"]);
}, ModalContent, function (props) {
  return props.background ? props.theme[props.background] : "none";
}, function (props) {
  return props.fullscreen ? "100%" : "auto";
}, media.desktop(_templateObject));

/**
 * The actual modal component, renders in a portal attached to the body
 */
var ModalWrapper = React.forwardRef(function (_ref2, ref) {
  var open = _ref2.open,
      background = _ref2.background,
      fullscreen = _ref2.fullscreen,
      children = _ref2.children;

  var content = React.createElement(
    ModalDimmer,
    { open: open },
    React.createElement(
      ModalContentWrapper,
      {
        open: open,
        background: background,
        fullscreen: fullscreen
      },
      React.createElement(
        ModalContent,
        { role: "dialog", "aria-modal": "true", tabIndex: "-1", ref: ref },
        children
      )
    )
  );

  if (typeof window !== "undefined" && document && document.body) {
    return ReactDOM.createPortal(content, document.body);
  }
  return null;
});

ModalDimmer.propTypes = {
  open: PropTypes.bool
};

ModalContent.propTypes = {
  background: PropTypes.string,
  fullscreen: PropTypes.bool
};

ModalWrapper.propTypes = {
  open: PropTypes.bool,
  background: PropTypes.string,
  fullscreen: PropTypes.bool
};

var Modal = (_temp2 = _class = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      animating: false,
      open: _this.props.open
    }, _this.targetRef = React.createRef(), _this.targetElement = null, _this._setOpen = function (open) {
      var update = function update() {
        _this.blockBodyScroll(open);
        _this.setState({ open: open });
        setTimeout(function () {
          return _this.setState({ animating: false });
        }, DELAY);
      };

      if (open) {
        _this.setState({ animating: true });
      }
      // Trigger css "appear" animation
      requestAnimationFrame(update);
    }, _this.toggle = function () {
      return _this._setOpen(!_this.state.open);
    }, _this.blockBodyScroll = function (block) {
      try {
        if (block) {
          disableBodyScroll(_this.targetRef.current);
        } else {
          enableBodyScroll(_this.targetRef.current);
        }
      } catch (e) {
        console.warn(e.toString());
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.componentDidMount = function componentDidMount() {
    this.targetElement = this.targetRef.current;
    if (this.state.open) {
      this.blockBodyScroll(this.state.open);
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.open !== this.props.open) {
      this._setOpen(this.props.open);
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    clearAllBodyScrollLocks();
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        background = _props.background,
        content = _props.content,
        fullscreen = _props.fullscreen,
        children = _props.children;

    var trigger = children && React.createElement(
      "span",
      { onClick: this.toggle },
      children
    );

    return React.createElement(
      "div",
      { className: className },
      (this.state.open || this.state.animating) && React.createElement(
        ModalWrapper,
        {
          ref: this.targetRef,
          open: this.state.open,
          background: background,
          fullscreen: fullscreen
        },
        React.cloneElement(content, {
          toggle: this.toggle
        })
      ),
      trigger
    );
  };

  return Modal;
}(React.Component), _class.defaultProps = {
  open: false
}, _temp2);

// Styled component hooks

Modal.propTypes = process.env.NODE_ENV !== "production" ? {
  open: PropTypes.bool,
  children: PropTypes.node,
  content: PropTypes.object,
  background: PropTypes.string
} : {};
Modal.Dimmer = ModalDimmer;
Modal.Content = ModalContent;

export default styled(Modal).withConfig({
  displayName: "Modal",
  componentId: "cq621u-3"
})([""]);